export default "__VITE_ASSET__gYwPBobl__"